export enum PaymentStatus {
    Pending = 'Pending',
    Paid = 'Paid',
    Failed = 'Failed',
    Authorized = 'Authorized',
    PartiallyRefunded = 'PartiallyRefunded',
    Refunded = 'Refunded',
    Processing = 'Processing',
    Canceled = 'Canceled',
    OnHold = 'OnHold',
    Disputed = 'Disputed',
    RequiresAction = 'RequiresAction',
}

export const PaymentStatusTranslations: Record<PaymentStatus, string> = {
    [PaymentStatus.Pending]: 'قيد الانتظار',
    [PaymentStatus.Paid]: 'مدفوع',
    [PaymentStatus.Failed]: 'فشل الدفع',
    [PaymentStatus.Authorized]: 'مصرح به',
    [PaymentStatus.PartiallyRefunded]: 'تم رد جزء من المبلغ',
    [PaymentStatus.Refunded]: 'تم رد المبلغ بالكامل',
    [PaymentStatus.Processing]: 'قيد المعالجة',
    [PaymentStatus.Canceled]: 'تم الإلغاء',
    [PaymentStatus.OnHold]: 'في الانتظار',
    [PaymentStatus.Disputed]: 'تم الاعتراض',
    [PaymentStatus.RequiresAction]: 'يتطلب إجراء',
};